import { createActionGroup, props } from '@ngrx/store';

export const tealiumTrackingActions = createActionGroup({
    source: 'Tealium Tracking',
    events: {
        addVolatile: props<{ key: string; value: string | string[] }>(),
        trackChangeLanguage: props<{ language: string }>(),
        trackPageView: props<{ title: string; customEvent?: object }>(),
        trackDocumentDownloadEvent: props<{ filetype: string; title: string; downloadUrl: string }>(),
        trackButtonClickEvent: props<{ buttonName: string; buttonTarget: string }>(),
        trackInteractionEvent: props<{
            elementName: string;
            elementType: string;
            elementValue: string;
            interactionType: string;
        }>(),
    },
});
